import { createContext } from "react";
const backgroundContext = createContext();
export default backgroundContext;